import React from 'react';
import {connect} from 'react-redux';
import NonControlledHitterStackMarker from 'components/organisms/non-controlled-hitter-stacking/services/non-controlled-hitter-stack-marker';
import {DesktopTeamsCombinations} from '../desktop-teams-combinations';

class TeamsCombinations extends DesktopTeamsCombinations {
    constructor(props) {
        super(props);
        this.marker = NonControlledHitterStackMarker;
    }
}

function mapStatesToProps(state) {
    const {lineupsData, lineupTeamsCombinations, filterLineupsByTeamCombinations} = state;

    return {
        rawLineups: lineupsData.rawLineups,
        lineupTeamsCombinations,
        filterLineupsByTeamCombinations,
    };
}

const ComboSummary = connect(mapStatesToProps)(TeamsCombinations);

export {ComboSummary};
